import { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { isAuth, useAsyncEffect } from '@recargas-dominicanas/core/utils';
import { useOpenPopup } from '@recargas-dominicanas/core/hooks';
import { AdminStore } from '../../store/adminStore';
import { useProductStore } from '../../store/productStore';
import { BusinessStore } from '../../store/businessStore';
import { BankStore } from '../../store/bankStore';
import { BankAccountStore } from '../../store/bankAccountStore';
import { ProviderStore } from '../../store/providerStore';
import { AppReleaseStore } from '../../store/appReleaseStore';
import { FinanceStore } from '../../store/financeStore';
import { UserProfile } from '../../components/user-profile/user-profile.component';
import logo from '../../images/recargas-dominicanas.svg';
import errorImage from '../../images/server-error.png';

import { 
  ErrorPage,
  Header, 
  Navbar,
  NavbarOption
} from '@recargas-dominicanas/core/components';

import { style } from './main.module.css';

export function Main() {

  const admin = AdminStore.get();
  const productStore = useProductStore();
  const openProfile = useOpenPopup();
  const navigate = useNavigate();

  const [isLoading, setLoading] = useState(true);
  const [loadFailed, setLoadFailed]= useState(false);

  useAsyncEffect(async () => {

    const auth = await isAuth('admin');

    if (!auth) return navigate('/login');

    try {

      await Promise.all([
        AdminStore.fetch(),
        BusinessStore.fetchAll(),
      ]);
      
      BankStore.fetchAll();
      productStore.fetch();
      ProviderStore.fetchAll();
      BankAccountStore.fetchAll();
      AppReleaseStore.fetchAll();
      FinanceStore.fetch();
      
      setLoading(false);

    } catch {

      setLoadFailed(true);
    }
  });

  if (isLoading) {
    return null;
  }

  if (loadFailed) {
    return <ErrorPage image={errorImage}/>;
  }

  return (
    <div className={style.container}>
      <Header
        logo={logo}
        title='Admin Recargas Dominicanas'
        name={`${admin.name}, Administrador`} 
        onOpenProfile={openProfile.handleOpen}/>
      <div className={style.body}>
        <Navbar style={style.navBar}>
          <NavbarOption align='top' icon='groups' route='/'/>
          <NavbarOption align='top' icon='account_balance' route='/bank-accounts'/>
          <NavbarOption align='top' icon='inventory_2' route='/products'/>
          <NavbarOption align='top' icon='widgets' route='/providers'/>
          <NavbarOption align='top' icon='donut_large' route='/finances'/>
          <NavbarOption align='top' icon='rocket_launch' route='/app-releases'/>
        </Navbar>
        <div className={style.content}>
          <Outlet/>
        </div>
      </div>
      <UserProfile 
        open={openProfile.open}
        admin={admin}
        onClose={openProfile.handleClose}/>
    </div>
  );
}
